import React, { Fragment } from 'react';
import * as Constants from '../../../../constants';
import {availableForSelectedOrderType, verifyStatus} from '../../../../helpers/customizedItem/customizedItem.helper';
import { IItemActions } from '../../../../models/try2Combo';
import AddToComboButton from './Buttons/AddToComboButton';
import CustomizeButton from './Buttons/CustomizeButton';
import NotAvailableButton from './Buttons/NotAvailableButton';
import {useAppSelector} from "../../../../redux/store/store";

const ItemActions: React.FC<IItemActions> = ({
  item,
  customizeModal,
  addToComboClickHandler,
}) => {
  const isOrderTypeSelected = useAppSelector(
      (state) => state.cart.isOrderTypeSelected
  );
  const savedOrderType = useAppSelector(
      (state) => state.cart.orderType
  );
  const orderType = isOrderTypeSelected ? savedOrderType : ""
  const isItemActive = () => {
    // ? This is hardcoded right now because have no constant to distiguise CREATE YOUR OWN SALAD.
    // if(isItCreateYourOwnItem(item?.is_create_your_own)){
    //   return false
    // }
    if(item.is_active && verifyStatus(item, 'item_location')){
      return true;
    } else{
      return false;
    }
  }
  const handleAddToComboClickHandler = () => {
    if(item?.category_id == 3 && item?.items_required_modifier_groups.length <= 0){
      customizeModal(item)
    }else{
      addToComboClickHandler(item)
    }
  }
  return (
    <Fragment>
      {isItemActive() && availableForSelectedOrderType(item, orderType ) ? (
        <div className="d-flex align-items-center flex-wrap">
          <CustomizeButton item={item} customizeModal={customizeModal} />
          <AddToComboButton
            item={item}
            addToComboClickHandler={handleAddToComboClickHandler}
          />
        </div>
      ) : (
        <NotAvailableButton item={item}/>
      )}
    </Fragment>
  );
};

export default ItemActions;
